import api from './api';

export interface PlaceReviewData {
  placeId: string;
  coffeeInDescription?: string;
  coffeeInImage?: string;
}

export interface PlaceForReview {
  id: string;
  name: string;
  logoUrl: string;
  type: string;
  cityName: string;
  stateName: string;
  coffeeInDescription?: string;
  coffeeInImage?: string;
  hasReview: boolean;
}

export const coffeeInReviewsService = {
  // Get all places (for list view)
  async getAllPlacesForReview(): Promise<PlaceForReview[]> {
    try {
      // Get all places from all cities
      const citiesResponse = await api.get('/places/cities');
      const cities = citiesResponse.data;
      const allPlaces: PlaceForReview[] = [];

      // For each city, fetch places
      for (const city of cities) {
        try {
          const placesResponse = await api.get(`/places/city-id/${city.id}`);
          const places = placesResponse.data.map((place: any) => ({
            id: place.id,
            name: place.name,
            logoUrl: place.logoUrl,
            type: place.type,
            cityName: place.cityName || city.name,
            stateName: place.stateName || '',
            coffeeInDescription: place.coffeeInDescription,
            coffeeInImage: place.coffeeInImage,
            hasReview: !!place.coffeeInDescription,
          }));

          allPlaces.push(...places);
        } catch (error) {
          console.error(`Error fetching places for city ${city.name}:`, error);
        }
      }

      return allPlaces;
    } catch (error) {
      console.error('Error fetching places for review:', error);
      throw error;
    }
  },

  // Get review data for a specific place
  async getPlaceReview(placeId: string): Promise<PlaceReviewData | null> {
    try {
      const response = await api.get(`/places/${placeId}`);

      return {
        placeId: response.data.id,
        coffeeInDescription: response.data.coffeeInDescription,
        coffeeInImage: response.data.coffeeInImage,
      };
    } catch (error) {
      console.error('Error fetching place review:', error);
      throw error;
    }
  },

  // Update CoffeeIn review for a place
  async updatePlaceReview(
    placeId: string,
    data: Partial<PlaceReviewData>
  ): Promise<void> {
    try {
      await api.put(`/places/${placeId}/coffeein-review`, {
        coffeeInDescription: data.coffeeInDescription,
        coffeeInImage: data.coffeeInImage,
      });
    } catch (error) {
      console.error('Error updating place review:', error);
      throw error;
    }
  },
};

